module.exports = __webpack_public_path__ + "img/ewm1.49cd5cc1.png";